var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtcv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "n8wq7dgm5a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.839216 0 0 0 0 0.709804 0 0 0 0 0.427451 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1070 -72) translate(825 72)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H25V25H0z",
    transform: "translate(245)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.654 0v2.06c.28-.024.56-.04.846-.04.285 0 .567.016.846.04V0H9.654zM1.508 11.5c0 4.908 4.026 8.887 8.992 8.887 4.966 0 8.992-3.979 8.992-8.887S15.466 2.613 10.5 2.613c-4.966 0-8.992 3.98-8.992 8.887zm1.499 0c0-4.09 3.355-7.406 7.493-7.406s7.493 3.316 7.493 7.406-3.355 7.406-7.493 7.406S3.007 15.59 3.007 11.5zm15.342-5.444c.324.455.608.938.848 1.447L21 6.474l-.846-1.448-1.805 1.03zM0 6.474l1.803 1.029c.24-.509.524-.992.848-1.447L.846 5.026 0 6.474zm10.753-.702v1.44H9.609v-1.44H8.465v1.44h-2.29V8.26h.49c.37 0 .6.045.69.134.091.09.136.308.136.657v4.887c0 .35-.045.568-.135.657-.09.09-.32.134-.69.134h-.491v1.047h2.29v1.453H9.61v-1.453h1.144v1.453h1.144v-1.477c.89-.055 1.563-.212 2.012-.475.61-.366.916-.975.916-1.827 0-1.236-.706-1.973-2.117-2.212 1.162-.322 1.743-.98 1.743-1.974 0-.739-.258-1.265-.775-1.58-.411-.25-1.007-.399-1.78-.45v-1.46h-1.143zM9.609 8.26h.749c.654 0 1.125.089 1.414.267.288.177.432.503.432.977 0 .491-.146.832-.439 1.022-.292.19-.783.286-1.472.286H9.61V8.259zm0 3.598h.788c.774 0 1.325.094 1.652.281.362.213.543.587.543 1.123 0 .57-.181.966-.543 1.187-.318.196-.86.293-1.627.293H9.61v-2.884zm8.74 5.087l1.805 1.03.846-1.448-1.803-1.029c-.24.509-.524.993-.848 1.447zM0 16.526l.846 1.448 1.805-1.03c-.324-.454-.608-.938-.848-1.447L0 16.526zm10.5 4.453c-.285 0-.567-.014-.846-.039V23h1.692v-2.06c-.279.025-.56.04-.846.04z",
    transform: "translate(245) translate(2 1)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtcv);
export default __webpack_public_path__ + "static/media/btcv.a16e2d9c.svg";
export { ForwardRef as ReactComponent };